import { easings } from "../../../../../../config";
import { css } from "@linaria/core";

export const TRANSITION_DURATION_MS = 200;

export const dropdownCls = css`
  background: #fff;
  border-top: 2px solid #000;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  margin-top: 10px;

  &-enter {
    transform: translateY(-6px);
    opacity: 0;

    transition: transform ${TRANSITION_DURATION_MS * 0.8}ms ${easings.inOutQuad},
      opacity ${TRANSITION_DURATION_MS}ms linear;
  }

  &-enter-active {
    transform: translateY(0);
    opacity: 1;
  }

  &-exit {
    transform: translateY(0);
    opacity: 1;

    transition: transform ${TRANSITION_DURATION_MS * 0.8}ms ${easings.inOutQuad}
        ${TRANSITION_DURATION_MS * 0.2}ms,
      opacity ${TRANSITION_DURATION_MS}ms linear;
  }

  &-exit-active {
    transform: translateY(6px);
    opacity: 0;
  }
`;

export const arrowCls = css`
  position: absolute;
  top: -10px;
  left: calc(50% - 5px);

  border-bottom: 10px solid #000;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
`;
